export const VIDEO_ENSURE_IDENTITY = '/video/ensure-identity'
